module.exports = __webpack_public_path__ + "static/kentpark-web-673f01184c90c4d9a7c2e73b49f62e02.jpg";